import * as apiRoutes from '../../apiRoutes';
import { actionTypes } from "../../actionTypes";
import { AuthUrl, ErrorData, errorTypes } from "../../constants";
import * as api from '../../tools/apiMiddleware';
import { isValidEmail, isStringNullOrWhiteSpace } from '../../tools/validator';
import { stat } from 'fs';
import EmailVerification from '../../components/Auth/EmailVerification';

export const EmailVerificationStep = {
    None: 0,
    Sent: 1,
    Completed: 2,
    Expired: 3,
    EmailAddressVerified: 4,
    Gateway: 5,
    Logout: 6
};

const initialState = {
    step: EmailVerificationStep.None,
    previousStep: EmailVerification.None,
    isLoading: false,
    hasErrorOccured: false,
    errorData: ErrorData
};

export const actionCreators = {
    getEmailVerificationStatus: () => async (dispatch) => {

        let url = AuthUrl + apiRoutes.GetEmailVerificationStatus;
        await api.getRequest(dispatch, url, actionTypes.VERIFY_EMAIL, actionTypes.VERIFY_EMAIL_STATUS_SUCCESS, actionTypes.VERIFY_EMAIL_FAIL);

    },
    sendEmailVerificationLink: () => async (dispatch) => {

        let url = AuthUrl + apiRoutes.SendEmailVerificationLink;
        await api.postRequest(dispatch, url, null, actionTypes.VERIFY_EMAIL, actionTypes.VERIFY_EMAIL_SUCCESS, actionTypes.VERIFY_EMAIL_FAIL, true);

    },
    resendEmailVerificationLink: () => async (dispatch) => {
        let url = AuthUrl + apiRoutes.ResendEmailVerificationLink;
        await api.postRequest(dispatch, url, null, actionTypes.VERIFY_EMAIL, actionTypes.VERIFY_EMAIL_SUCCESS, actionTypes.VERIFY_EMAIL_FAIL, true);

    },
    verifyEmailByLink: (guid) => async (dispatch) => {

        let url = AuthUrl + apiRoutes.VerifyEmailByLink + `/${guid}`;
        await api.postRequest(dispatch, url, null, actionTypes.VERIFY_EMAIL, actionTypes.VERIFY_EMAIL_LINK_SUCCESS, actionTypes.VERIFY_EMAIL_FAIL, true);

    },
    goGateway: () => async (dispatch) => {
        await dispatch({ type: actionTypes.VERIFY_EMAIL_GATEWAY });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case actionTypes.VERIFY_EMAIL:
            return {
                ...state,
                isLoading: true,
                hasErrorOccured: false
            };
        case actionTypes.VERIFY_EMAIL_STATUS_SUCCESS:
            let step = EmailVerificationStep.None;
            if (action.data.status === 1)
                step = EmailVerificationStep.Sent;
            else if (action.data.status === 2)
                step = EmailVerificationStep.Completed;
            else if (action.data.status === 3)
                step = EmailVerificationStep.Expired;

            return {
                ...state,
                step,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.VERIFY_EMAIL_LINK_SUCCESS:
            let success = true;
            if (action.data.status === 1)
                success = false;

            return {
                ...state,
                step: success ? EmailVerificationStep.EmailAddressVerified : EmailVerificationStep.Expired,
                isLoading: false,
                hasErrorOccured: false,
                errorData: ErrorData
            };
        case actionTypes.VERIFY_EMAIL_SUCCESS:
            let nextStep = state.step;
            let errorMessage = '';
            if (action.data.status === 0) {
                if (state.step === EmailVerificationStep.None || state.step === EmailVerificationStep.Expired) {
                    nextStep = EmailVerificationStep.Sent;
                }
            }
            else {
                errorMessage = 'we couldn`t send a verification email because of technical difficulties.';
            }

            return {
                ...state,
                step: nextStep,
                previousStep: state.step,
                isLoading: false,
                hasErrorOccured: action.data.status === 1,
                errorData: { message: errorMessage }
            };
        case actionTypes.VERIFY_EMAIL_GATEWAY:
            return {
                ...state,
                step: EmailVerificationStep.Gateway,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.VERIFY_EMAIL_FAIL:

            if (action.data.errorType === errorTypes.Unauthorized) {
                return {
                    ...state,
                    isLoading: false,
                    step: EmailVerificationStep.Logout,
                    hasErrorOccured: false
                };
            }

            return {
                ...state,
                isLoading: false,
                hasErrorOccured: true,
                errorData: action.data
            };
    }
    return state;
};


// WEBPACK FOOTER //
// ./src/store/Auth/EmailVerificationStore.js